import { useShallow } from 'zustand/shallow'

import { useStore, getEdgesSelector } from '@app/store'
import type { DomainEdge } from '@app/types'

type UseGetEdges = (strategyId: string) => DomainEdge[]

const useGetEdges: UseGetEdges = (strategyId) => useStore(useShallow((state) => getEdgesSelector(state, strategyId)))

export default useGetEdges
